/* eslint-disable jira/integration/test-id-by-folder-structure */
import React from 'react';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import Skeleton from '@atlaskit/skeleton';
import VisuallyHidden from '@atlaskit/visually-hidden/visually-hidden';
import { useIntl, defineMessage } from '@atlassian/jira-intl';

const loadingMessage = defineMessage({
	id: 'servicedesk-availability.agents-table-skeleton.loading',
	defaultMessage: 'Loading agents',
	description: 'Accessible loading message for screen readers while agents table is loading',
});

export type AvailableAgentsTableSkeletonProps = {
	/** Number of rows to display (default: 6) */
	rowCount?: number;
};

export const AvailableAgentsTableSkeleton = ({
	rowCount = 6,
}: AvailableAgentsTableSkeletonProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Stack space="space.300" testId="availability.ui.available-agents-table.agents-table-skeleton">
			<VisuallyHidden>{formatMessage(loadingMessage)}</VisuallyHidden>
			{Array.from({ length: rowCount }).map((_, index) => (
				<Skeleton key={index} height="64px" width="100%" />
			))}
		</Stack>
	);
};
